import { createFileRoute } from "@tanstack/react-router";
import EnergyManagementOverview from "@/pages/EnergyManagementOverview";
import { hubHead } from "@/lib/route-seo";

export const Route = createFileRoute("/energy-management/")({
  head: () => hubHead("/energy-management"),
  component: EnergyManagementOverview,
});
